import { render, staticRenderFns } from "./vSupplementLabelCanada.vue?vue&type=template&id=7d4a299a&scoped=true"
import script from "./vSupplementLabelCanada.vue?vue&type=script&setup=true&lang=ts"
export * from "./vSupplementLabelCanada.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vSupplementLabelCanada.vue?vue&type=style&index=0&id=7d4a299a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a299a",
  null
  
)

export default component.exports